



























































































































































































import { Component } from "vue-property-decorator";
import ClientDataSectionDialogComponent from "./ClientDataSectionDialog.vue";
import { ProjectDetails } from "../../../data/models/ProjectDetails";
import { getTargetAppVersion } from "@/data/repository/ClientRepository";
import { uploadPdfDocument } from "@/utils/pdf/PdfDocumentRepository";
import { COLOR_ACCENT, COLOR_PRIMARY } from "@/utils/colors";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";

@Component({
  components: {
    "confirmation-dialog": ConfirmationDialogComponent,
  },
})
export default class PolicyHolderSectionComponent extends ClientDataSectionDialogComponent {
  isDirectOrder = false;
  showTitleInput = getTargetAppVersion() >= 1064;

  file2: File | null = null;
  initialFileName2: string | null = null;
  fileName2: string | null = null;

  private snapshotTitle = "";
  private snapshotFirstName = "";
  private snapshotLastName = "";
  private snapshotCountryCode = "";
  private snapshotZipCode = "";
  private snapshotCity = "";
  private snapshotStreet = "";
  private snapshotHouseNumber = "";
  private snapshotPhone = "";
  private snapshotMobilePhone = "";
  private snapshotEmail = "";
  private snapshotPdfDocument: string | null = null;
  private snapshotPdfDocument2: string | null = null;

  hasInitialData(): boolean {
    const info = this.projectDetails.clientData.policyHolderInfo;
    return !!(info.title || info.firstName || info.lastName || info.countryCode
      || info.zipCode || info.city || info.street || info.houseNumber
      || info.phone || info.mobilePhone || info.emailAddress
      || this.projectDetails.pdfDocument || this.projectDetails.pdfDocument2);
  }

  takeSnapshot(): void {
    const info = this.projectDetails.clientData.policyHolderInfo;
    this.snapshotTitle = info.title ?? "";
    this.snapshotFirstName = info.firstName ?? "";
    this.snapshotLastName = info.lastName ?? "";
    this.snapshotCountryCode = info.countryCode ?? "";
    this.snapshotZipCode = info.zipCode ?? "";
    this.snapshotCity = info.city ?? "";
    this.snapshotStreet = info.street ?? "";
    this.snapshotHouseNumber = info.houseNumber ?? "";
    this.snapshotPhone = info.phone ?? "";
    this.snapshotMobilePhone = info.mobilePhone ?? "";
    this.snapshotEmail = info.emailAddress ?? "";
    this.snapshotPdfDocument = this.projectDetails.pdfDocument ?? null;
    this.snapshotPdfDocument2 = this.projectDetails.pdfDocument2 ?? null;
  }

  get hasChanged(): boolean {
    const info = this.projectDetails.clientData.policyHolderInfo;
    return (info.title ?? "") !== this.snapshotTitle
      || (info.firstName ?? "") !== this.snapshotFirstName
      || (info.lastName ?? "") !== this.snapshotLastName
      || (info.countryCode ?? "") !== this.snapshotCountryCode
      || (info.zipCode ?? "") !== this.snapshotZipCode
      || (info.city ?? "") !== this.snapshotCity
      || (info.street ?? "") !== this.snapshotStreet
      || (info.houseNumber ?? "") !== this.snapshotHouseNumber
      || (info.phone ?? "") !== this.snapshotPhone
      || (info.mobilePhone ?? "") !== this.snapshotMobilePhone
      || (info.emailAddress ?? "") !== this.snapshotEmail
      || (this.projectDetails.pdfDocument ?? null) !== this.snapshotPdfDocument
      || (this.projectDetails.pdfDocument2 ?? null) !== this.snapshotPdfDocument2;
  }

  async show(projectDetails: ProjectDetails) {
    this.isDirectOrder = projectDetails.clientData.directOrder === true;

    if (projectDetails.pdfDocument && projectDetails.pdfDocument !== "") {
      this.initialFileName = projectDetails.pdfDocument;
      this.fileName = this.initialFileName;
    }
    else {
      this.fileName = null;
    }

    if (projectDetails.pdfDocument2 && projectDetails.pdfDocument2 !== "") {
      this.initialFileName2 = projectDetails.pdfDocument2;
      this.fileName2 = this.initialFileName2;
    } else {
      this.fileName2 = null;
    }

    return this.showDialog(
      this.$t(
        this.isDirectOrder
          ? "clientData.client"
          : "clientData.policyHolder"
      ).toString(),
      projectDetails
    );
  }

  onAccept() {
    this.isShowing = false;

    if (this.file && this.projectDetails.pdfDocument) {
      if (this.fileName && this.initialFileName !== this.fileName) {
        uploadPdfDocument(this.fileName, this.file);
      }
    }

    if (this.file2 && this.projectDetails.pdfDocument2) {
      if (this.fileName2 && this.initialFileName2 !== this.fileName2) {
        uploadPdfDocument(this.fileName2, this.file2);
      }
    }

    this.resolve && this.resolve(this.projectDetails);
  }

  get colorAccent() {
    return COLOR_ACCENT;
  }

  get colorPrimary() {
    return COLOR_PRIMARY;
  }

  removeAttachedDocument(pdfIndex: number) {
    if (pdfIndex === 1) {
      this.file = null;
      this.$set(this.projectDetails, "pdfDocument", null);
      this.fileName = "";
    } else {
      this.file2 = null;
      this.$set(this.projectDetails, "pdfDocument2", null);
      this.fileName2 = "";
    }

    this.resetUploadInput(pdfIndex);
  }

  handleFileUpload(file: File, pdfIndex: number) {
    if (file && file.type === "application/pdf") {
      if (pdfIndex === 1) {
        this.file = file;
        this.fileName = file.name;
        this.$set(this.projectDetails, "pdfDocument", file.name);
      } else {
        this.file2 = file;
        this.fileName2 = file.name;
        this.$set(this.projectDetails, "pdfDocument2", file.name);
      }
    }
  }

  resetUploadInput(pdfIndex: number) {
    const refName = pdfIndex === 1 ? "upload" : "upload2";
    const uploadInput = this.$refs[refName] as HTMLInputElement | undefined;

    if (uploadInput) {
      uploadInput.value = "";
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleDrop(event: any, pdfIndex: number) {
    event.preventDefault();
    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      const file = event.dataTransfer.files[0];
      if (file.type === "application/pdf") {
        this.handleFileUpload(file, pdfIndex);
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleInputChange(event: any, pdfIndex: number) {
    const target = event.target as HTMLInputElement;
    const file = target?.files && target.files.length > 0 ? target.files[0] : null;

    if (file && file.type === "application/pdf") {
      this.handleFileUpload(file, pdfIndex);
    }

    this.resetUploadInput(pdfIndex);
  }
}
